<template>
  <div class="register">
    <img src="@/assets/images/pexels.png" alt class="login-left" />
    <div class="login-box">
      <ul class="tabs">
        <li class="tab-item">{{$t('MAIN_WEB_WELCOME_TO_REGISTER',{text:'欢迎注册'})}}！</li>
      </ul>
      <el-form ref="form" :model="register" :rules="rules">
        <div class="signInform">
          <el-form-item prop="account">
            <el-input
              :placeholder="$t('MAIN_WEB_PLEASE_ENTER_YOUR_MOBILE_PHONE_NUMBER',{text:'请输入手机号'})"
              v-model="register.account"
              clearable
            >
              <img slot="prepend" src="@/assets/images/xiaoren.png" alt />
            </el-input>
          </el-form-item>
          <el-form-item prop="authCode">
            <el-input :placeholder="$t('MAIN_WEB_PLEASE_ENTER_A_VERIFICATION_CODE',{text:'请输入验证码'})" v-model="register.authCode">
              <img slot="prepend" src="@/assets/images/yanzheng.png" alt />
              <el-button slot="append" @click="postAccountGetAuthCode" round>{{
                0 >= Countdown ? $t('MAIN_WEB_OBTAIN_VERIFICATION_CODE',{text:'获取验证码'}) : Countdown
              }}</el-button>
            </el-input>
          </el-form-item>
          <input
            type="text"
            style="position:absolute;display:block;width:0;height:0;border-width:0"
          />
          <el-form-item prop="password">
            <el-input
              :placeholder="$t('MAIN_WEB_SET_PASSWORD',{text:'设置密码'})"
              v-model="register.password"
              auto-complete="new-password"
              show-password
            >
              <img slot="prepend" src="@/assets/images/mima.png" alt />
            </el-input>
          </el-form-item>
          <p class="passwordTip">8-20{{$t('MAIN_WEB_COMBINATION_PASSWORD_OF_DIGITS_DIGITS_UPPERCASE_AND',{text:'位，数字、大小写字母、字符组合密码'})}}</p>
        </div>
        <!-- <div class="bottom">
                    <span class="fl" v-show="$route.name === 'register'">
                        <el-checkbox v-model="read">$t('MAIN_WEB_I_HAVE_READ_AND_AGREE',{text:'我已阅读并同意'})</el-checkbox>
                        <a class="aname" @click="handleClose">$t('MAIN_WEB_USER_AGREEMENT',{text:'《用户协议》'})</a>
                    </span>
                    <div class="clear"></div>
                </div> -->
        <el-form-item>
          <el-button type="primary" @click="onSubmit">{{$t('MAIN_WEB_REGISTRATION',{text:'注册'})}}</el-button>
        </el-form-item>
        <div>
          <span class="tip">
            {{$t('MAIN_WEB_EXISTING_ACCOUNT',{text:'已有账号？'})}}
            <router-link
              :to="{ name: 'login', query: { account: this.register.account } }"
              >{{$t('MAIN_WEB_LOG_ON_NOW',{text:'马上登录'})}}</router-link
            >
          </span>
        </div>
      </el-form>
    </div>

    <!-- <el-dialog
            title="$t('MAIN_WEB_USER_AGREEMENT_YOI',{text:'用户协议'})"
            :fullscreen="true"
            :close-on-click-modal="true"
            :visible.sync="dialogVisible"
            :before-close="handleClose"
        >
            <Agreement />
        </el-dialog> -->
  </div>
</template>

<script>
// import Agreement from "./agreement.vue";
import {
  phoneNumberValidator,
  passwordValidator,
  isPhone
} from "@/util/validate";
export default {
  name: "register",
  // components: { Agreement },
  data() {
    return {
      read: false,
      Countdown: 0,
      dialogVisible: false,
      register: {
        account: "",
        password: "",
        authCode: ""
      },
      stopClick: false,
    };
  },
  computed: {
    rules(){
      return {
            account: [
          {
            required: true,
            message: this.$t('MAIN_WEB_PLEASE_ENTER_YOUR_MOBILE_PHONE_NUMBER',{text:'请输入手机号'}),
            trigger: "blur"
          },
          {
            validator: phoneNumberValidator,
            trigger: "blur",
            message: this.$t('MAIN_WEB_PLEASE_ENTER_THE_CORRECT_MOBILE_PHONE_NUMBER',{text:'请输入正确的手机号'})
          }
        ],
        password: [
          { required: true, message: this.$t('MAIN_WEB_ENTER_A_PASSWORD',{text:'请输入密码'}), trigger: "blur" },
          {
            validator: passwordValidator,
            trigger: "blur"
          }
        ],
        authCode: [
          {
            required: true,
            message: this.$t('MAIN_WEB_PLEASE_ENTER_A_VERIFICATION_CODE',{text:'请输入验证码'}),
            trigger: "blur"
          },
          {
            min: 6,
            max: 6,
            message: this.$t('MAIN_WEB_PLEASE_ENTER_A_SIXDIGIT_VERIFICATION_CODE',{text:'请输入六位验证码'}),
            trigger: "blur"
          }
        ]
      }
    }
  },
  created() {},
  mounted() {
    localStorage.clear();
    sessionStorage.clear();
    this.$store.state.nav = [];
  },
  methods: {
    onSubmit() {
      if (this.stopClick) {
        return false;
      }
      this.stopClick = true;
      setTimeout(() => {
        this.stopClick = false;
      }, 5000);
      this.$refs.form.validate(valid => {
        if (valid) {
          this.postAccountRegister();
        } else {
          return false;
        }
      });
    },
    // 注册
    postAccountRegister() {
      const data = {
        ...this.register
      };
      this.$api.operate.postCompanyRegister({ data }).then(res => {
        if (res.data) {
          this.$message.success(this.$t('MAIN_WEB_REGISTERED_SUCCESSFULLY',{text:'注册成功'}));
          localStorage.setItem("token", res.data);
          sessionStorage.setItem("token", res.data);
          setTimeout(() => {
            this.$router.push({ name: "organ" });
          }, 500);
        }
      });
    },
    // 获取验证码
    postAccountGetAuthCode() {
      // const data = {
      //     phone: this.register.account,
      //     adminFlag: 1
      // };
      const data = { account: this.register.account, type: 2 };
      if (!isPhone.test(data.account)) return;
      // if ( !isPhone.test(data.phone) ) return;
      if (this.Countdown > 0) return;
      this.Countdown = 60;
      // this.$api.operate.postAccountGetAuthCode({ data }).then(() => {
      //     this.setCountdown();
      // });
      this.$api.operate.getAuthCodeCommon({ data }).then(() => {
        this.setCountdown();
      });
    },
    setCountdown() {
      let Countdown = null;

      Countdown = setInterval(() => {
        this.Countdown--;
        if (this.Countdown <= 0) {
          clearInterval(Countdown);
        }
      }, 1000);
    },
    handleClose() {
      this.dialogVisible = !this.dialogVisible;
    }
  }
};
</script>

<style lang="stylus" scoped>
@import './css/signIn';

.register {
  .tabs .tab-item {
    margin-bottom: 0;
    color: #000;
  }

  .bottom {
    padding-top: 30px;
    color: #666666;

    .aname {
      color: #3E6CE7 !important;
      cursor: pointer;
    }
  }

  .tip {
    color: #666666;

    a {
      cursor: pointer;
      color: #3E6CE7 !important;
    }
  }
}

/deep/ .el-form-item__error {
  left: 18px;
}

/deep/ .el-input__inner {
  -webkit-box-shadow: 0 0 0 1000px #ffffff inset;
}
</style>
